<template>
  <transition name="fade">
    <div class="wrapper" v-if="show" @click="onClick">
      <div class="headerWrapper">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          class="headerItem"
          :class="{
            active: activeTab === tab.value,
            clicked: maxTab >= tab.value,
          }"
          @click="setTab(tab.value)"
        >
          {{ tab.text }}
        </div>
      </div>
      <div class="contentWrapper" v-if="activeTab === 1">
        <div class="title">Enter the name of your job post</div>
        <input class="input-name" v-model="title" />
        <div>
          <div class="title">Here are some good examples:</div>
          <div class="title">-Helpdesk engineer for Mac/PC environment</div>
          <div class="title">-VOip engineer for 6 month project</div>
          <div class="title">-Okta installation engineer</div>
        </div>
        <button class="submit primary button" @click="nextStep">
          Next Step
        </button>
      </div>
      <div class="contentWrapper" v-if="activeTab === 2">
        <div class="title">A good description includes:</div>
        <div>
          <div class="title">What the deliverable is</div>
          <div class="title">What the task is</div>
        </div>
        <div>
          <textarea class="textarea-desc" v-model="task" />
        </div>
        <div class="upload-wrapper">
          <div class="upload-title">Additional project files (optional)</div>
          <div class="upload-content-wrapper">
            <div class="upload-content">
              <div v-if="!files || files.length === 0">
                drag or <span> upload </span> project docs
              </div>
              <div v-if="files.length > 0">
                {{ files.map((item) => item.name) }}
              </div>
            </div>
            <input
              class="upload-input"
              type="file"
              @change="onChange"
              multiple
            />
          </div>
          <div class="upload-desc">
            You may attach up to 5 files under 100 MB each
          </div>
        </div>
        <button class="submit primary button" @click="nextStep">
          Next Step
        </button>
      </div>
      <div class="contentWrapper" v-if="activeTab === 3">
        <div class="title">List of skills required for the role:</div>
        <div>
          <div class="title">Example:</div>
          <div class="title">2 years of mac helpdesk support experience</div>
          <div class="title">1 year of active directory experience</div>
        </div>
        <div>
          <textarea class="textarea-desc" v-model="skills" />
        </div>
        <button class="submit primary button" @click="nextStep">
          Next Step
        </button>
      </div>
      <div class="contentWrapper" v-if="activeTab === 4">
        <div>
          <div class="title">Budget per hour for techs</div>
          <input class="input-line" v-model="rate_per_hour" />
        </div>
        <div>
          <div class="title">Project Length (Ex: 40 hours, 6 month, etc)</div>
          <input class="input-line" v-model="engagement" />
        </div>
        <div>
          <div class="title">Location</div>
          <input class="input-line" v-model="location" />
        </div>
        <div>
          <div class="title">Work type (Remote/onsite)</div>
          <!-- <input class="input-line" v-model="work_type" /> -->
          <div>
            <model-select
              :options="workTypeOptions"
              v-model="work_type"
            ></model-select>
          </div>
        </div>
        <div>
          <div class="title">Estimated Start Date</div>
          <!-- <input class="input-line" v-model="estimated_start" /> -->
          <div class="form-inline">
            <VueCtkDateTimePicker
              id="start"
              v-model="estimated_start"
              :right="true"
              :no-label="false"
              :no-value-to-custom-elem="true"
              format="YYYY-MM-DD HH:mm"
              formatted="llll"
            >
              <input type="text" id="startTime" :value="estimated_start" />
            </VueCtkDateTimePicker>
          </div>
        </div>
        <spinnerButton
          class="submit primary button"
          @click.native="finish"
          :loading="isLoading"
        >
          Finish adding the project
        </spinnerButton>
      </div>
    </div>
  </transition>
</template>

<script>
import { addDoc } from "@/vendor/database";
import spinnerButton from "@/components/public/SpinnerButton";
import moment from "moment";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { randomString } from "@/utils/utils";
import { storagePut, storageGetDownloadUrl } from "@/vendor/firebase";

const tabs = [
  {
    value: 1,
    text: "1. Title",
  },
  {
    value: 2,
    text: "2. Task/Description",
  },
  {
    value: 3,
    text: "3. Skills",
  },
  {
    value: 4,
    text: "4. Details",
  },
];

export default {
  components: {
    spinnerButton,
    VueCtkDateTimePicker,
    ModelSelect,
  },
  props: ["show", "company"],
  data() {
    return {
      activeTab: 1,
      tabs: tabs,
      maxTab: 1,
      files: [],

      title: "",
      task: "",
      skills: "",
      rate_per_hour: "",
      engagement: "",
      location: "",
      work_type: "",
      estimated_start: "",

      isLoading: false,
      workTypeOptions: [
        { text: "remote", value: "remote" },
        { text: "onsite", value: "onsite" },
      ],
    };
  },
  mounted() {
    this.tran = "tran";
  },
  methods: {
    onClick: function (e) {
      e.stopPropagation();
    },
    setTab: function (value) {
      if (value > this.maxTab) return;
      this.activeTab = value;
    },
    onChange: function (e) {
      this.files = (Object.entries(e.target.files) || [])
        .filter((item, index) => {
          if (index >= 5) return false;
          return item[1].size < 1024 * 1024 * 1000;
        })
        .map((item) => item[1]);
    },
    checkStepOne: function () {
      if (!this.title) {
        this.$toasted.global.toast_error({
          message: "please enter the name of your job post",
        });
        if (this.activeTab !== 1) {
          this.activeTab = 1;
        }
        return false;
      }
      return true;
    },
    checkStepTwo: function () {
      if (!this.task) {
        this.$toasted.global.toast_error({
          message: "please enter the description",
        });
        if (this.activeTab !== 2) {
          this.activeTab = 2;
        }
        return false;
      }
      return true;
    },
    checkStepThree: function () {
      if (!this.skills) {
        this.$toasted.global.toast_error({
          message: "please enter the skills",
        });
        if (this.activeTab !== 3) {
          this.activeTab = 3;
        }
        return false;
      }
      return true;
    },
    checkStepFour: function () {
      if (
        !this.rate_per_hour ||
        !this.engagement ||
        !this.location ||
        !this.work_type ||
        !this.estimated_start
      ) {
        this.$toasted.global.toast_error({
          message: "please enter the info",
        });
        if (this.activeTab !== 4) {
          this.activeTab = 4;
        }
        return false;
      }
      return true;
    },
    nextStep: function () {
      if (this.activeTab === 1 && !this.checkStepOne()) return;
      if (this.activeTab === 2 && !this.checkStepTwo()) return;
      if (this.activeTab === 3 && !this.checkStepThree()) return;
      this.activeTab += 1;
      if (this.maxTab < this.activeTab) {
        this.maxTab = this.activeTab;
      }
    },
    finish: async function () {
      if (
        this.checkStepOne() &&
        this.checkStepTwo() &&
        this.checkStepThree() &&
        this.checkStepFour()
      ) {
        this.isLoading = true;
        const files = [];
        if (this.files && this.files.length > 0) {
          for (const item of this.files) {
            const res = await storagePut(
              `clients/${this.company}/`,
              item.name,
              item
            );
            if (res.ok) {
              const res = await storageGetDownloadUrl(
                `clients/${this.company}/${item.name}`
              );
              if (res.ok) {
                files.push({
                  name: item.name,
                  url: res.data,
                });
              }
            }
          }
        }
        addDoc("gigs", {
          title: this.title,
          task: this.task,
          skills: this.skills,
          roles: [
            {
              id: randomString(10),
              requirements: this.skills,
              title: this.title,
            },
          ],
          rate_per_hour: this.rate_per_hour,
          engagement: this.engagement,
          location: this.location,
          work_type: this.work_type,
          estimated_start:
            moment(this.estimated_start, "YYYY-MM-DD HH:mm").valueOf() / 1000,
          created: moment().valueOf() / 1000,
          company: this.company,
          phase: "Active searching",
          public: "true",
          files,
        })
          .then((res) => {
            if (res.ok) {
              this.$toasted.global.toast_success("success");
              this.$emit("closePanel");
              this.$emit("clickItem", res.data);
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>


<style scoped>
.wrapper {
  position: absolute !important;
  width: 800px;
  height: 100%;
  border: 1px solid var(--border-grey-lightest);
  background: #fff;
  right: 0;
  display: flex;
  flex-direction: column;
}
.headerWrapper {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--border-grey-lightest);
}
.headerItem {
  height: 50px;
  flex-basis: 25%;
  text-align: center;
  line-height: 50px;
  font-size: 16px;
  font-weight: 900;
  position: relative;
  color: var(--font-color-lighter);
}
.headerItem.active::after {
  content: "";
  width: 200px;
  height: 4px;
  background: var(--blue);
  left: 0;
  bottom: 0;
  position: absolute;
}
.headerItem.clicked {
  cursor: pointer;
  color: var(--font-color-base);
}
.headerItem.clicked:hover {
  background: var(--grey-lightest);
}
.contentWrapper {
  flex-grow: 1;
  padding: 3rem;
  overflow: scroll;
}
.contentWrapper > *:not(:first-child) {
  margin-top: 2rem;
}
.input-name {
  border: 1px solid var(--grey);
  border-radius: 8px;
  display: block;
  height: 2.5rem;
  outline: none;
  width: 100%;
  padding: 0 0.5rem !important;
  font-size: 16px;
}
.title {
  font-weight: bold;
  font-size: 16px;
  line-height: 18px;
}
.button {
  min-width: 220px;
  cursor: pointer;
}
.textarea-desc {
  border: 1px solid var(--grey);
  border-radius: 8px;
  display: block;
  height: 260px;
  outline: none;
  width: calc(100% - 1rem);
  padding: 0.5rem !important;
  font-size: 16px;
}
.upload-wrapper > *:not(:first-child) {
  margin-top: 0.5rem;
}
.upload-title {
  font-size: 14px;
}
.upload-desc {
  font-size: 12px;
}
.upload-content {
  height: 80px;
  border: 2px dashed green;
  background: var(--grey-lightest);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.upload-content-wrapper {
  position: relative;
}
.upload-content > div > span {
  color: green;
  margin: 0 0.25rem;
}
.upload-input {
  width: 100%;
  height: 80px;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  opacity: 0;
}
.input-line {
  border: 0;
  border-bottom: 1px solid var(--grey);
  display: block;
  height: 2.5rem;
  outline: none;
  width: 100%;
  padding: 0 0.5rem !important;
  font-size: 16px;
  margin-top: 1rem;
}
</style>
